(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selectorGroups = [
    ['.swh-rd-hero__text', 'left'],
    ['.swh-rd-hero__media', 'right'],
    ['.swh-rd-promises__item', 'up'],
    ['.swh-rd-routes .swh-rd-eyebrow, .swh-rd-routes .swh-rd-heading, .swh-rd-route', 'up'],
    ['.swh-rd-pillars__intro', 'left'],
    ['.swh-rd-pillar', 'up'],
    ['.swh-rd-products__head, .swh-rd-product-card, .swh-rd-products__footer', 'up'],
    ['.swh-about__hero-content', 'left'],
    ['.swh-about__hero-media', 'right'],
    ['.swh-about__section-head, .swh-about__team-intro, .swh-about__person', 'up'],
    ['.swh-about__story-media', 'left'],
    ['.swh-about__story-copy > *, .swh-about__value, .swh-about__step, .swh-about__cta-inner > *', 'up'],
    ['.swh-shop-intro__inner > *', 'up'],
    ['.swh-shop-flow .swh-panel', 'up'],
    ['.swh-shop-flow .swh-category-btn, .swh-shop-flow .swh-solution-card', 'up'],
    ['.swh-shop-flow .swh-note-card, .swh-shop-flow .swh-pro-card', 'up'],
    ['[data-swh-motion-root] [data-swh-reveal]', 'up']
  ];

  let observer;

  const mark = (element, direction, index) => {
    if (element.dataset.swhRevealReady === 'true') return;
    element.dataset.swhReveal = direction;
    element.dataset.swhRevealReady = 'true';
    element.style.setProperty('--swh-reveal-delay', `${Math.min(index % 4, 3) * 70}ms`);

    if (reduceMotion.matches) {
      element.classList.add('is-visible');
      return;
    }

    observer.observe(element);
  };

  const scan = (root = document) => {
    selectorGroups.forEach(([selector, direction]) => {
      root.querySelectorAll(selector).forEach((element, index) => mark(element, direction, index));
    });
  };

  const init = () => {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => entry.target.classList.toggle('is-visible', entry.isIntersecting));
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });

    scan();

    const shopFlow = document.querySelector('.swh-shop-flow');
    if (shopFlow) {
      new MutationObserver(() => scan(shopFlow)).observe(shopFlow, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['hidden']
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
